import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/domains/general/api/client';

import { type EventFilters, eventKeys } from './keys';
import type { AssigneeListResponse, CaseDetail, CaseListResponse } from './types';

export const eventQueries = {
  list: (filters?: EventFilters) =>
    queryOptions({
      queryKey: eventKeys.list(filters),
      queryFn: (): Promise<CaseListResponse> => {
        const params = new URLSearchParams();
        if (filters?.status) params.append('status', filters.status);
        if (filters?.page) params.append('page', String(filters.page));
        if (filters?.limit) params.append('limit', String(filters.limit));
        if (filters?.search) params.append('search', filters.search);
        if (filters?.assignee) params.append('assignee', filters.assignee);
        if (filters?.statusOrder) params.append('statusOrder', filters.statusOrder);
        const qs = params.toString();
        return apiFetch(`/cases${qs ? `?${qs}` : ''}`);
      },
    }),

  detail: (id: string) =>
    queryOptions({
      queryKey: eventKeys.detail(id),
      queryFn: (): Promise<CaseDetail> => apiFetch(`/cases/${id}`),
      enabled: !!id,
    }),

  assignees: () =>
    queryOptions({
      queryKey: eventKeys.assignees(),
      queryFn: (): Promise<AssigneeListResponse> => apiFetch('/cases/assignees'),
    }),
};

export function useEvents(filters?: EventFilters) {
  return useQuery(eventQueries.list(filters));
}

export function useEvent(id: string) {
  return useQuery(eventQueries.detail(id));
}

export function useAssignees() {
  return useQuery(eventQueries.assignees());
}
